<template>
  <div style="height: 100%;">
    <slot></slot>
  </div>
</template>

<script>
import esriComponent from '../../mixins/esri-component';
import {loadModules} from 'esri-loader';

export default {
  provide () {
    return {
      getMap: this.getMap,
      getLayers: this.getLayers
    };
  },
  mixins: [esriComponent],
  methods: {
    /**
     * @Override
     */
    async loadEsriModules () {
      return await loadModules(['esri/Map']);
    },
    /**
     * @returns {Promise<Map>}
     * @Override
     */
    async createEsriObject () {
      const [Map] = this.$esriModules;
      return new Map();
    },
    getMap () {
      return this.$esriObject;
    },
    getLayers () {
      return this.$esriObject ? this.$esriObject.layers : null;
    }
  }
};
</script>
